import { cloneElement, useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE_ADD_ITM,
    COMN_URLS_ADD_ITM,
    APIS_ADD_ITM,
    SF_APP_DTL_ADD_ITM,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppAddItmService";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn";

const TANCIS_LINK_ADTNL_ITM_CD_NO_LIST = ["OGAZ00010000001"];

export const APP_DTL_ADD_ITM = (props: any) => {
    // console.log("APP_DTL_ADD_ITM props ", props);

    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /** #add-item# additional item */
    const refAddItmList = useRef<any[]>([]); /** addtional item info list */
    const [stateAddItmSchemas, setStateAddItmSchemas] = useState<any[] | undefined>([]);
    const refTemp = useRef<any[]>([]);

    useResource({
        defaultSchema: [], //{ area: "comnCd", comnCd: "" }
    });

    const form = props.form;

    const fetch = {
        /** #add-item# additional item */
        getAdtnlItmByAppCdNoList: useFetch({
            api: (appCdNo, data) => {
                return APIS_ADD_ITM.getAdtnlItmByAppCdNoList(appCdNo, data);
            },
            onSuccess: (data) => {
                // console.log("getAdtnlItmByAppCdNoList ==================== ", data.adtnlItmList?.content);
                refAddItmList.current = data.adtnlItmList?.content || [];
                form.appDtlAddItm.setValue("orginAdtnlItmList", refAddItmList.current);
                setStateAddItmSchemas(
                    APIS_ADD_ITM.getAdtnlItmSchemas(form.appDtlAddItm, data.adtnlItmList?.content || [], true),
                );
            },
            onError: () => {},
            showToast: false,
        }),
        /** #add-item# additional item */
        getAdtnlItmValueList: useFetch({
            api: (appId, data) => {
                return APIS_ADD_ITM.getAdtnlItmValueList(appId, data);
            },
            onSuccess: (data) => {
                // console.log("getAdtnlItmValueList ==================== ", data);
                refAddItmList.current = data.adtnlItmList?.content || [];
                form.appDtlAddItm.setValue("orginAdtnlItmList", refAddItmList.current);
                setStateAddItmSchemas(
                    APIS_ADD_ITM.getAdtnlItmSchemas(form.appDtlAddItm, data.adtnlItmList?.content || [], false),
                );
            },
            onError: () => {},
            showToast: false,
        }),
    };

    const handler = {};

    useEffect(() => {
        /** #add-item# additional item */
        const appCdNo = props.param.appCdNo;
        const appId = props.param.appId;
        const appClsfCd = props.param.appClsfCd;
        const areaCd = props.area;
        const itemNo = props.itemNo;

        const appDgr = props.param.appDgr;
        const appStatCd = props.param.appStatCd;

        const paramData = {
            additmCpntCd: areaCd,
            appCdNo: appCdNo,
            itmNo: itemNo,
            appDgr: appDgr,
            appStatCd: appStatCd,
        };

        // No additional items for classification X !== 신청서 분류 X는 추가 항목 미표시 ==!
        if (appClsfCd === "X") {
            refAddItmList.current = [];
            setStateAddItmSchemas([]);
            return;
        }

        if (appId) {
            fetch.getAdtnlItmValueList.fetch(appId, paramData);
        } else if (appCdNo) {
            fetch.getAdtnlItmByAppCdNoList.fetch(appCdNo, paramData);
        }
    }, [
        props.param?.appId,
        props.param?.appCdNo,
        props.param?.appClsfCd,
        props.param?.appDgr,
        props.param?.appStatCd,
        props.area,
        props.itemNo,
    ]);

    return (
        <>
            {stateAddItmSchemas && stateAddItmSchemas.length > 0 && (
                <Layout direction="col">
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_ADTNL_INFO"} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        {stateAddItmSchemas.map((elem, idx) => {
                            let rightButton = null;
                            if (refAddItmList.current[idx].inpTpCd == "CP") {
                                rightButton = APIS_ADD_ITM.getFormRightButtonCP(
                                    elem.inputName,
                                    elem.comnCd,
                                    form.appDtlAddItm,
                                    modal,
                                );
                            } else if (refAddItmList.current[idx].inpTpCd == "SP") {
                                rightButton = APIS_ADD_ITM.getFormRightButtonPP(
                                    elem.inputName,
                                    refAddItmList.current[idx].adtnlItmCdNo,
                                    form.appDtlAddItm,
                                    modal,
                                );
                            }

                            if (refAddItmList.current[idx].inpTpCd != "CP") {
                                console.log("elem ", refAddItmList.current[idx]);
                                refTemp.current.push(
                                    <Group.Control
                                        key={elem.inputName}
                                        {...form.appDtlAddItm.schema[elem.inputName]}
                                        rightButton={rightButton}
                                        // {...(TANCIS_LINK_ADTNL_ITM_CD_NO_LIST.includes(
                                        //     refAddItmList.current[idx].adtnlItmCdNo,
                                        // )
                                        //     ? {
                                        //           as: "link",
                                        //           onClick: () => {
                                        //               modal.openModal({
                                        //                   url: `${lpcoEnvs.base}/lpco/tansad/osci0202002q/${refAddItmList.current[idx].adtnlItmCn}`,
                                        //                   draggable: true,
                                        //                   callback: (data) => {
                                        //                       modal.closeModal();
                                        //                   },
                                        //               }); // TODO: 링크 클릭 시 동작 구현
                                        //           },
                                        //       }
                                        //     : {})}
                                    />,
                                );
                            } else {
                                refTemp.current.push(
                                    cloneElement(
                                        APIS_ADD_ITM.getFormComponentComnCd(
                                            elem,
                                            form.appDtlAddItm,
                                            elem.inputName,
                                            rightButton,
                                        ),
                                        { key: elem.inputName },
                                    ),
                                );
                            }
                            if (idx % 2 == 1 || idx == stateAddItmSchemas.length - 1) {
                                let temp = [...refTemp.current];
                                refTemp.current = [];

                                return <Group.Row key={`row-${idx}`}>{temp}</Group.Row>;
                            }
                            return null;
                        })}
                    </Group.Section>
                </Layout>
            )}
        </>
    );
};
